module.exports = __webpack_public_path__ + "c002cd789eb43641c98b7817ee26e3e3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-BoldItalic.ttf
// module id = 1269
// module chunks = 0